module.exports = __webpack_public_path__ + "img/product-placeholder.1fbd293d.jpg";